const initialise = () => {
    window.addEventListener('click', (e) => {
        if (e.target && e.target.classList.contains('mentionable')) {
            if (e.target.classList.contains('missing')) {
                // Don't do anything if the mentionable is missing - it will be styled differently to indicate this, but we don't want to throw an error or lose the tag entirely
                return;
            }
            e.preventDefault();
            switch (e.target.dataset.model) {
                case 'BudgetEntry':
                    Eventbus.$emit('budget:entry', {
                        event: e.target.dataset.event,
                        entry: e.target.dataset.id,
                    });
                    break;
                case 'PurchaseOrder':
                    Eventbus.$emit('purchaseOrder:view', {
                        event: e.target.dataset.event,
                        purchaseOrder: e.target.dataset.id,
                    });
                    break;
                case 'RevenueEntry':
                    Eventbus.$emit('revenue:entry', {
                        entry: e.target.dataset.id,
                    });
                    break;
                default:
                    break;
            }
        }
    });
};

export const mentionables = {
    initialise,
};
